import type { MarqEntry } from './api';
const REFUNDS = new Set(['refund', 'match_refund']);

export function rewardEntryLabel(entry: MarqEntry): string {
  if (entry.kind === 'daily') return entry.action === 'streak' ? entry.note || 'Daily reward + streak bonus' : 'Daily reward';
  if (entry.kind === 'signup') return 'Welcome bonus';
  if (entry.kind === 'reward') return entry.note || 'Mission reward';
  if (entry.kind === 'season_prize') return entry.note || 'Leaderboard prize';
  if (entry.kind === 'upvote') return entry.note || 'Upvote in Camps';
  if (entry.kind === 'downvote') return entry.note || 'Camp vote adjustment';
  if (entry.kind === 'learn') return entry.note || 'Language reward';
  if (entry.kind === 'award_get') return 'Award received';
  if (entry.kind === 'award_give') return 'Award given';
  if (entry.kind === 'admin') return entry.note || 'Wallet adjustment';
  if (REFUNDS.has(entry.kind)) return entry.note || 'Refund';
  if (entry.kind.startsWith('match_')) return entry.note || 'Online match';
  if (entry.action.startsWith('item:')) return entry.note || 'Game item purchase';
  return ({ translate: 'Translation', pronounce: 'Pronunciation', transcribe: 'Voice transcription', ocr: 'Image reading', image: 'Image request' } as Record<string, string>)[entry.action] || entry.note || 'KHARMA activity';
}

